import { Box } from "@circleco/compass/components/Box";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface SettingsBlockProps {
  children: ReactNode;
  description?: ReactNode;
  title: string;
}

export const SettingsBlock = ({
  title,
  description,
  children,
}: SettingsBlockProps) => (
  <Box as="section" className="mb-6 flex flex-col gap-6">
    <div className="flex flex-col gap-1">
      <Typography variant="label-md" component="h2">
        {title}
      </Typography>
      {!!description && (
        <Typography variant="body-sm" color="secondary" component="p">
          {description}
        </Typography>
      )}
    </div>
    <div className="flex flex-col gap-6">{children}</div>
  </Box>
);
